import './PerformanceDetailsLayoutScreen.scss';
import BackComponent from "../../../shared/components/back/BackComponent";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import FacilityDetailsComponent from "../facility-details/FacilityDetailsComponent";
import {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import {useNavigate, useParams} from "react-router-dom";
import PerformanceRecordDetailsScreen from "../performance-record-details/PerformanceRecordDetailsScreen";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";

interface PerformanceDetailsLayoutScreenProps {

};

const PerformanceDetailsLayoutScreen = (props: PerformanceDetailsLayoutScreenProps) => {
    const navigate = useNavigate();
    const {performanceRecordId} = useParams();
    const [loading, setLoading] = useState(false);
    const [getPerformanceRecordData, setGetPerformanceRecordData] = useState<any>(null);
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [isRestrictModalOpen, setIsRestrictModalOpen] = useState<boolean>(false);

    const navigateToClientCases = useCallback(() => {
        navigate(CommonService._routeConfig.ClientCases());
    }, [navigate]);

    const getPerformanceRecordDetails = useCallback((performanceRecordId: string) => {
        setLoading(true);
        CommonService._cases.PerformanceRecordViewDetails(performanceRecordId)
            .then(response => {
                setLoading(false);
                setGetPerformanceRecordData(response.data);
            }).catch(error => {
            setLoading(false);
            console.log(error);
            setGetPerformanceRecordData(null);
        })

    }, []);

    useEffect(() => {
        if (performanceRecordId) {
            getPerformanceRecordDetails(performanceRecordId);
        }
    }, [performanceRecordId, getPerformanceRecordDetails]);

    const handleBookAppointment = useCallback(() => {
        if (currentUser?.independent_appointment_booking === 'Restricted') {
            setIsRestrictModalOpen(true)
        } else {
            navigate(CommonService._routeConfig.BookAppointmentRoute())
        }
    }, [currentUser, navigate]);


    console.log('getPerformanceRecordData', getPerformanceRecordData)

    return (
        <div className="performance-details-layout-screen">
            <div className="list-screen__header">
                <div className="list-screen__header-title">
                    <BackComponent onClick={navigateToClientCases}/>
                </div>
                <div className={'contact-appointment-wrapper'}>
                    <div className={'contact-number-wrapper'}>
                        <div className={'contact-message'}>For any questions or concerns, please <span
                            onClick={() => setIsContactUsModalOpen(true)}
                            className={'contact-us'}>contact us.</span></div>
                    </div>
                    {getPerformanceRecordData?.status === 'open' &&
                        <ButtonComponent onClick={handleBookAppointment} className={'mrg-left-15'}>Book
                            Appointment</ButtonComponent>
                    }
                </div>
            </div>
            {
                loading && <LoaderComponent/>
            }
            {!loading && <PerformanceRecordDetailsScreen performanceRecordData={getPerformanceRecordData}/>}

            <ModalComponent isOpen={isContactUsModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-20 mrg-top-10'}
                                                          onClick={() => setIsContactUsModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsContactUsModalOpen(false)}>
                <FacilityDetailsComponent title={'Contact Us'}/>
            </ModalComponent>
            <ModalComponent isOpen={isRestrictModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-30 mrg-top-10'}
                                                          onClick={() => setIsRestrictModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsRestrictModalOpen(false)}>
                <FacilityDetailsComponent
                    title={<>Online Booking Unavailable.<br/> Contact us to book an appointment.</>}/>
            </ModalComponent>
        </div>
    )
}
export default PerformanceDetailsLayoutScreen;
